module.exports = __webpack_public_path__ + "img/somosHome_1_small.d9f3a3af.jpg";